import p from "./index47.js";
import u from "./index46.js";
import m from "./index54.js";
import "./index48.js";
import "./index30.js";
import "./index55.js";
import "./index58.js";
class d extends m {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      to: t = this.to || 0,
      from: r = this.from || 0,
      maxLength: i = this.maxLength || 0,
      autofix: a = this.autofix,
      ...h
    } = e;
    this.to = t, this.from = r, this.maxLength = Math.max(String(t).length, i), this.autofix = a;
    const o = String(this.from).padStart(this.maxLength, "0"), n = String(this.to).padStart(this.maxLength, "0");
    let s = 0;
    for (; s < n.length && n[s] === o[s]; )
      ++s;
    h.mask = n.slice(0, s).replace(/0/g, "\\0") + "0".repeat(this.maxLength - s), super._update(h);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(e) {
    let t = "", r = "";
    const [, i, a] = e.match(/^(\D*)(\d*)(\D*)/) || [];
    return a && (t = "0".repeat(i.length) + a, r = "9".repeat(i.length) + a), t = t.padEnd(this.maxLength, "0"), r = r.padEnd(this.maxLength, "9"), [t, r];
  }
  doPrepareChar(e, t) {
    t === void 0 && (t = {});
    let r;
    return [e, r] = super.doPrepareChar(e.replace(/\D/g, ""), t), e || (r.skip = !this.isComplete), [e, r];
  }
  _appendCharRaw(e, t) {
    if (t === void 0 && (t = {}), !this.autofix || this.value.length + 1 > this.maxLength)
      return super._appendCharRaw(e, t);
    const r = String(this.from).padStart(this.maxLength, "0"), i = String(this.to).padStart(this.maxLength, "0"), [a, h] = this.boundaries(this.value + e);
    return Number(h) < this.from ? super._appendCharRaw(r[this.value.length], t) : Number(a) > this.to ? !t.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength ? super._appendCharRaw(r[this.value.length], t).aggregate(this._appendCharRaw(e, t)) : super._appendCharRaw(i[this.value.length], t) : super._appendCharRaw(e, t);
  }
  doValidate(e) {
    const t = this.value;
    if (t.search(/[^0]/) === -1 && t.length <= this._matchFrom)
      return !0;
    const [i, a] = this.boundaries(t);
    return this.from <= Number(a) && Number(i) <= this.to && super.doValidate(e);
  }
  pad(e) {
    const t = new p();
    if (this.value.length === this.maxLength)
      return t;
    const r = this.value, i = this.maxLength - this.value.length;
    if (i) {
      this.reset();
      for (let a = 0; a < i; ++a)
        t.aggregate(super._appendCharRaw("0", e));
      r.split("").forEach((a) => this._appendCharRaw(a));
    }
    return t;
  }
}
u.MaskedRange = d;
export {
  d as default
};
